module.exports = __webpack_public_path__ + "static/laboheme0-862ad799be0a6828e4243eefb04bcd43.jpg";